<div class="rule-editor-container">
  <div class="rule-editor-header">
    <h3>{{ title() | translate }}</h3>
    <p>{{ description() | translate }}</p>
  </div>
  <div class="editor-wrapper">
    <textarea 
      class="rule-textarea"
      [formControl]="editorFormControl"
      rows="10"
      placeholder="IF $.conversation.conversation_data.status EQUALS 'open' AND $.conversation.conversation_data.priority EQUALS 'high' DO SEND_MESSAGE WITH 'high_priority_template'
ELSEIF $.conversation.conversation_data.status CHANGED DO NOTIFY_PARTICIPANTS
ELSEIF $.conversation.conversation_data.assignee CHANGED_FROM_TO 'agent1' 'agent2' DO SEND_MESSAGE WITH 'reassigned_template'
ELSEIF $.conversation.conversation_data.tags EXIST DO NOTIFY_PARTICIPANTS
ELSE DO SEND_MESSAGE WITH 'default_template'"
    ></textarea>
  </div>
</div> 